module.exports = __webpack_public_path__ + "media/img/apple-icon-60x60-ab90e0c4c5927dffc405b9885b9ce229.png";